import { render, staticRenderFns } from "./application-form.vue?vue&type=template&id=912a6a12&scoped=true&"
import script from "./application-form.vue?vue&type=script&lang=js&"
export * from "./application-form.vue?vue&type=script&lang=js&"
import style0 from "./application-form.vue?vue&type=style&index=0&id=912a6a12&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "912a6a12",
  null
  
)

export default component.exports